(function () {
  'use strict';

  /**
   * TDLS Gang Sheet — UI Bridge
   * Replaces Drip Apps default buttons with TDLS-styled buttons.
   * The original app elements are hidden but kept in the DOM so the
   * app's event listeners and state management continue to work.
   */

  function replaceBuilderButton() {
    var appBtn = document.getElementById('gs-builder-btn');
    if (!appBtn || appBtn.dataset.gsReplaced) return;
    appBtn.dataset.gsReplaced = '1';

    var wrapper = appBtn.closest('.gs--wrapper');
    if (!wrapper) return;

    // Hide original app button (keep in DOM for event listeners)
    appBtn.style.cssText = 'position:absolute!important;opacity:0!important;pointer-events:none!important;width:0!important;height:0!important;overflow:hidden!important;';

    // Create TDLS primary button
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tdls-btn tdls-btn--primary gs-tdls-builder-btn';
    btn.innerHTML = '<i class="fas fa-layer-group"></i>&nbsp; Build Your Gang Sheet';
    btn.style.margin = '0 auto 40px';

    btn.addEventListener('click', function () {
      // Restore display temporarily for the click
      appBtn.style.pointerEvents = 'auto';
      appBtn.click();
      appBtn.style.pointerEvents = 'none';
    });

    wrapper.insertBefore(btn, appBtn);
  }

  function replaceBrowseButtons() {
    document.querySelectorAll('.gs-design-browse-btn').forEach(function (appBtn) {
      if (appBtn.dataset.gsReplaced) return;
      appBtn.dataset.gsReplaced = '1';

      // Hide original
      appBtn.style.cssText = 'position:absolute!important;opacity:0!important;pointer-events:none!important;width:0!important;height:0!important;overflow:hidden!important;';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tdls-btn tdls-btn--primary gs-tdls-browse-btn';
      btn.innerHTML = '<i class="fas fa-upload"></i>&nbsp; Browse Files';

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Temporarily restore for click passthrough
        appBtn.style.pointerEvents = 'auto';
        appBtn.click();
        appBtn.style.pointerEvents = 'none';
      });

      appBtn.parentNode.insertBefore(btn, appBtn);
    });
  }

  function replaceAddToCartButton() {
    var appBtn = document.getElementById('gs-add-cart-btn');
    if (!appBtn || appBtn.dataset.gsReplaced) return;
    appBtn.dataset.gsReplaced = '1';

    // Just restyle it — the app manages its own display: none / flex toggling
    // We can't replace it without breaking the app's state machine
    appBtn.classList.add('gs-tdls-cart-btn');
    // Remove the loader span the app adds (we use button text only when visible)
    var loader = appBtn.querySelector('.gs-loader');
    if (loader) loader.style.display = 'none';
  }

  function init() {
    replaceBuilderButton();
    replaceBrowseButtons();
    replaceAddToCartButton();
  }

  // App scripts are deferred — run after DOMContentLoaded + small tick
  // to ensure app listeners are in place before we manipulate the DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 50);
    });
  } else {
    setTimeout(init, 50);
  }

  // Also watch for any dynamically injected blocks (MutationObserver fallback)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector) {
            if (node.querySelector('#gs-builder-btn') || node.id === 'gs-builder-btn') {
              setTimeout(replaceBuilderButton, 50);
            }
            if (node.querySelector('.gs-design-browse-btn')) {
              setTimeout(replaceBrowseButtons, 50);
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Scroll-trigger: buttons around the page that open the builder ──
  function scrollToBuilder() {
    var target = document.getElementById('gang-sheet-builder');
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // After scroll completes, trigger the builder open
    setTimeout(function () {
      var appBtn = document.getElementById('gs-builder-btn');
      if (appBtn) {
        appBtn.style.pointerEvents = 'auto';
        appBtn.click();
        appBtn.style.pointerEvents = 'none';
      }
    }, 600);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.gs-trigger-builder, [href="#gang-sheet-builder"]');
    if (!trigger) return;

    // Only intercept if the gang sheet builder exists on this page
    var target = document.getElementById('gang-sheet-builder');
    if (target) {
      e.preventDefault();
      scrollToBuilder();
    }
    // Otherwise let the default link behavior (e.g. /pages/custom-order-builder) happen
  });
})();
